module.exports = __webpack_public_path__ + "img/feature-media.db68fa1d.svg";